import { axios, getAxiosConfig, ServerAxiosRequestData } from '@config/axios';
import { ApiResponse } from '@interfaces/api';
import Environment from '@config/environment';
import { ProductFeedPayload } from '@interfaces/api/payloads/product-feed-payload';
import { ProductFeedsResponse } from '@interfaces/api/responses/product-feed-response';
import { ProductFeed } from '@interfaces/models/product-feed';
import { ProductSearchHeaders } from '@services/search-service';

type Headers = {
  [ProductSearchHeaders.deviceId]: string;
  [ProductSearchHeaders.userId]: string;
};

export default class ProductFeedService {
  private static recommendApiBasePath = `${Environment.apiBaseUrl}/recommend`;

  static async getProductFeeds(
    payload: ProductFeedPayload,
    headers: Headers,
    serverAxiosRequestData?: ServerAxiosRequestData,
  ): Promise<ProductFeedsResponse> {
    const axiosConfig = getAxiosConfig(serverAxiosRequestData);

    const { data } = await axios.post<ProductFeedPayload, ApiResponse<ProductFeedsResponse>>(
      `${ProductFeedService.recommendApiBasePath}/product-feed`,
      payload,
      { ...axiosConfig, headers: { ...axiosConfig?.headers, ...headers } },
    );
    return data;
  }

  static async getSingleProductFeed(
    payload: ProductFeedPayload,
    headers: Headers,
    feedType: string,
    serverAxiosRequestData?: ServerAxiosRequestData,
  ): Promise<ProductFeed> {
    const axiosConfig = getAxiosConfig(serverAxiosRequestData);
    if (!/^[A-Za-z0-9_-]+$/.test(feedType)) {
      throw new Error(`Invalid feedType: ${feedType}`);
    }
    const safeFeedType = encodeURIComponent(feedType);

    const { data } = await axios.post<ProductFeedPayload, ApiResponse<ProductFeed>>(
      `${ProductFeedService.recommendApiBasePath}/product-feed/${safeFeedType}`,
      payload,
      { ...axiosConfig, headers: { ...axiosConfig?.headers, ...headers } },
    );

    return data;
  }
}
